import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/machinery")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
